module.exports = __webpack_public_path__ + "static/media/logo-silestone.7d16da28.svg";